export const CLEAR_EXCEPTION = 'CLEAR_EXCEPTION';
export const POP_EXCEPTION = 'POP_EXCEPTION';
export const CLOSE_EXCEPTION = 'CLOSE_EXCEPTION';

export function clearException(exception) {
  return {
    type: CLEAR_EXCEPTION,
    exception
  };
}

export function popException() {
  return {
    type: POP_EXCEPTION
  };
}

export function closeException(index) {
  return {
    type: CLOSE_EXCEPTION,
    index
  };
}
